import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'elapsedTime' })
export class ElapsedTimePipe implements PipeTransform {
  transform(elapsedTimeInMs: number): string {
    // get seconds
    const timeInSeconds = Math.floor(elapsedTimeInMs / 1000);
    const hours = Math.floor(timeInSeconds / 3600);
    const minutes = Math.floor(timeInSeconds / 60) % 60;
    const seconds = timeInSeconds % 60;

    if (hours > 0) {
      return pad(hours, 2) + ':' + pad(minutes, 2) + ' h';
    } else if (minutes > 0) {
      return pad(minutes, 2) + ':' + pad(seconds, 2) + ' min';
    } else {
      return pad(seconds, 2) + ' s';
    }
  }
}

function pad(value: string | number, size: number) {
  let s = String(value);
  while (s.length < (size || 2)) {
    s = '0' + s;
  }
  return s;
}
